/* ==========================================================================
   Itz Art — shell behaviour
   Header compaction (hysteresis), mega menu, mobile drawer, announcement
   rotator, search (three states, predictive API), cart drawer (Section
   Rendering API). One scroll listener, one keydown listener, no framework.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var mqDesktopNav = window.matchMedia('(min-width: 900px)');
  var mqHover = window.matchMedia('(hover: hover)');

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function lockScroll(lock) {
    var locks = (root.__itzLocks = root.__itzLocks || 0) + (lock ? 1 : -1);
    root.__itzLocks = Math.max(0, locks);
    root.classList.toggle('itz-locked', root.__itzLocks > 0);
  }

  /* ---- Header: compaction + panels ------------------------------------------- */
  var header = $('[data-itz-header]');
  var scrolled = false, panelOpen = null, searchOpen = false;

  function applyCompact() {
    if (!header) return;
    var compact = scrolled || searchOpen || panelOpen !== null;
    header.classList.toggle('is-compact', compact);
  }

  var ticking = false;
  on(window, 'scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY || root.scrollTop;
      // Hysteresis: on at y > 90, off at y < 30 — never a single threshold.
      if (!scrolled && y > 90) { scrolled = true; applyCompact(); }
      else if (scrolled && y < 30) { scrolled = false; applyCompact(); }
    });
  }, { passive: true });

  var panels = $$('[data-itz-panel]');
  var triggers = $$('[data-itz-panel-trigger]');
  var closeTimer = null, openTimer = null;

  function positionPanel(panel, trigger) {
    var card = $('[data-itz-panel-card]', panel);
    if (!card || !card.classList.contains('itz-panel__card--compact')) return;
    var host = panel.parentElement;
    var left = trigger.getBoundingClientRect().left - host.getBoundingClientRect().left - parseFloat(getComputedStyle(host).paddingLeft);
    card.style.setProperty('--itz-panel-left', Math.max(0, Math.round(left)) + 'px');
  }

  function openPanel(i) {
    if (!mqDesktopNav.matches) return;
    clearTimeout(closeTimer);
    if (panelOpen === i) return;
    closeSearch();
    panels.forEach(function (p) {
      var match = p.getAttribute('data-itz-panel') === String(i);
      p.hidden = !match;
    });
    triggers.forEach(function (t) {
      var match = t.getAttribute('data-itz-panel-trigger') === String(i);
      t.setAttribute('aria-expanded', match ? 'true' : 'false');
      if (match) {
        var p = $('[data-itz-panel="' + i + '"]');
        if (p) positionPanel(p, t);
      }
    });
    panelOpen = i;
    applyCompact();
  }
  function closePanels() {
    clearTimeout(openTimer);
    if (panelOpen === null) return;
    panels.forEach(function (p) { p.hidden = true; });
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    panelOpen = null;
    applyCompact();
  }

  triggers.forEach(function (t) {
    var i = t.getAttribute('data-itz-panel-trigger');
    on(t, 'mouseenter', function () {
      if (!mqHover.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPanel(i); }, 60);
    });
    on(t, 'click', function (e) {
      // Touch / keyboard: first activation opens the panel, second follows the link.
      if (mqHover.matches && mqDesktopNav.matches) return;
      if (!mqDesktopNav.matches) return;
      if (panelOpen !== i) { e.preventDefault(); openPanel(i); }
    });
    on(t, 'focus', function () { if (!mqHover.matches) return; });
  });
  $$('[data-itz-panel-none]').forEach(function (a) {
    on(a, 'mouseenter', function () { clearTimeout(openTimer); closeTimer = setTimeout(closePanels, 120); });
  });
  if (header) {
    on(header, 'mouseleave', function () { clearTimeout(openTimer); closeTimer = setTimeout(closePanels, 140); });
    on(header, 'mouseenter', function () { clearTimeout(closeTimer); });
  }
  panels.forEach(function (p) { on(p, 'mouseenter', function () { clearTimeout(closeTimer); }); });

  // Subjects rail: hover swaps the family pane
  $$('[data-itz-panel]').forEach(function (panel) {
    var rows = $$('[data-itz-fam-trigger]', panel);
    var panes = $$('[data-itz-fam-pane]', panel);
    function pick(i) {
      rows.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-itz-fam-trigger') === String(i)); });
      panes.forEach(function (pn) { var m = pn.getAttribute('data-itz-fam-pane') === String(i); pn.hidden = !m; pn.classList.toggle('is-active', m); });
    }
    rows.forEach(function (r) {
      var i = r.getAttribute('data-itz-fam-trigger');
      on(r, 'mouseenter', function () { pick(i); });
      on(r, 'focus', function () { pick(i); });
      on(r, 'click', function () { pick(i); });
    });
  });

  /* ---- Announcement rotator --------------------------------------------------- */
  $$('[data-itz-announce]').forEach(function (bar) {
    var notes = $$('[data-itz-announce-note]', bar);
    if (notes.length < 2) return;
    var idx = 0, interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000, timer;
    function show(n) {
      idx = (n + notes.length) % notes.length;
      notes.forEach(function (el, k) { el.classList.toggle('is-active', k === idx); });
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, interval); }
    on($('[data-itz-announce-prev]', bar), 'click', function () { show(idx - 1); start(); });
    on($('[data-itz-announce-next]', bar), 'click', function () { show(idx + 1); start(); });
    start();
  });

  /* ---- Mobile drawer ------------------------------------------------------------- */
  var drawer = $('[data-itz-drawer]');
  var drawerToggle = $('[data-itz-drawer-toggle]');
  var scrim = $('[data-itz-scrim]');
  var drawerOpen = false;

  function showView(id) {
    if (!drawer) return;
    $$('[data-itz-drawer-view]', drawer).forEach(function (v) {
      var m = v.getAttribute('data-itz-drawer-view') === id;
      v.hidden = !m;
      v.classList.toggle('is-active', m);
    });
    drawer.scrollTop = 0;
  }
  function placeDrawer() {
    // the drawer starts exactly under the sticky header: the announcement above it scrolls away, so a fixed offset leaves a gap
    if (!drawer || !drawerOpen || !header) return;
    drawer.style.top = Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px';
  }
  on(window, 'resize', placeDrawer);
  on(window, 'scroll', placeDrawer, { passive: true });
  function setDrawer(open) {
    if (!drawer) return;
    drawerOpen = open;
    drawer.hidden = !open;
    placeDrawer();
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { showView('root'); closeSearch(); }
    lockScroll(open);
  }
  on(drawerToggle, 'click', function () { setDrawer(!drawerOpen); });
  if (drawer) {
    on(drawer, 'click', function (e) {
      var go = e.target.closest('[data-itz-drawer-go]');
      if (go) { showView(go.getAttribute('data-itz-drawer-go')); return; }
      var back = e.target.closest('[data-itz-drawer-back]');
      if (back) { showView(back.getAttribute('data-itz-drawer-back')); }
    });
  }
  on(mqDesktopNav, 'change', function (e) { if (e.matches && drawerOpen) setDrawer(false); });

  /* ---- Search --------------------------------------------------------------------- */
  var search = $('[data-itz-search]');
  var searchToggle = $('[data-itz-search-toggle]');
  var searchInput = $('[data-itz-search-input]');
  var sIdle = $('[data-itz-search-idle]');
  var sResults = $('[data-itz-search-results]');
  var sNone = $('[data-itz-search-none]');
  var sColl = $('[data-itz-search-collections]');
  var sProd = $('[data-itz-search-products]');
  var sAll = $('[data-itz-search-all]');
  var sAllBar = $('[data-itz-search-allbar]');
  var sRecent = $('[data-itz-search-recent]');
  var sRecentList = $('[data-itz-search-recent-list]');
  var currencyPrefix = (root.getAttribute('data-itz-currency') || 'CA$').trim();
  var RECENT_KEY = 'itz-search-recent';
  var searchTimer = null, lastQuery = '', searchSeq = 0;

  function getRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function setRecent(list) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {} }
  function pushRecent(q) {
    q = (q || '').trim(); if (!q) return;
    var list = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q); setRecent(list); renderRecent();
  }
  function renderRecent() {
    if (!sRecent || !sRecentList) return;
    var list = getRecent();
    sRecent.hidden = list.length === 0;
    sRecentList.innerHTML = list.map(function (q) {
      return '<button type="button" class="itz-search__recent-item" data-itz-search-term="' + escapeHtml(q) + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>' +
        '<span>' + escapeHtml(q) + '</span></button>';
    }).join('');
  }
  on($('[data-itz-search-recent-clear]'), 'click', function () { setRecent([]); renderRecent(); });

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function formatPrice(p) {
    var n = parseFloat(String(p).replace(/[^\d.]/g, ''));
    if (isNaN(n)) return '';
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    return currencyPrefix + s;
  }
  function imgUrl(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + w + 'x$1$2');
  }

  function setSearchState(state) {
    if (sIdle) sIdle.hidden = state !== 'idle';
    if (sResults) sResults.hidden = state !== 'results';
    if (sNone) sNone.hidden = state !== 'none';
  }
  function openSearch() {
    if (!search) return;
    closePanels();
    if (drawerOpen) setDrawer(false);
    search.hidden = false;
    searchOpen = true;
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    if (searchInput) {
      if (!mqDesktopNav.matches) searchInput.placeholder = searchInput.getAttribute('data-placeholder-mobile') || searchInput.placeholder;
      setTimeout(function () { searchInput.focus(); }, 30);
    }
    renderRecent();
    if (!mqDesktopNav.matches) lockScroll(true);
    applyCompact();
  }
  function closeSearch() {
    if (!search || !searchOpen) return;
    search.hidden = true;
    searchOpen = false;
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    if (!mqDesktopNav.matches) lockScroll(false);
    applyCompact();
  }
  on(searchToggle, 'click', function () { searchOpen ? closeSearch() : openSearch(); });
  on($('[data-itz-search-close]'), 'click', function () { closeSearch(); });

  function runSearch(q) {
    q = q.trim();
    if (q === '') { setSearchState('idle'); lastQuery = ''; return; }
    if (q === lastQuery) return;
    lastQuery = q;
    var seq = ++searchSeq;
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    // Section-rendered feed (works through the theme-dev proxy; the .json endpoint is refused there)
    url += 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=itz-search-json&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { var m = html.match(/<script[^>]*data-itz-search-json[^>]*>([\s\S]*?)<\/script>/); return m ? JSON.parse(m[1]) : {}; })
      .then(function (data) {
        if (seq !== searchSeq) return;
        var res = (data && data.resources && data.resources.results) || {};
        var products = res.products || [], collections = res.collections || [];
        var allUrl = window.ItzSearch ? ItzSearch.url(q) : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'search?q=' + encodeURIComponent(q) + '&type=product');
        if (sAll) sAll.href = allUrl;
        if (sAllBar) sAllBar.href = allUrl;
        if (!products.length && !collections.length) { setSearchState('none'); return; }
        if (sColl) {
          sColl.innerHTML = collections.slice(0, 4).map(function (c) {
            return '<a class="itz-search__coll" href="' + escapeHtml(c.url) + '"><span class="itz-search__coll-label">' + escapeHtml(c.title) + '</span><span class="itz-search__coll-meta">Collection</span></a>';
          }).join('');
        }
        if (sProd) {
          sProd.innerHTML = products.slice(0, 5).map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(imgUrl(p.featured_image.url, 320)) + '" alt="' + escapeHtml(p.featured_image.alt || p.title) + '" loading="lazy">' : '<span class="itz-placeholder">Print</span>';
            return '<a class="itz-search__card" href="' + escapeHtml(p.url) + '"><span class="itz-search__card-img">' + img + '</span><span class="itz-search__card-title">' + escapeHtml(p.title) + '</span><span class="itz-search__card-price">From ' + formatPrice(p.price) + '</span></a>';
          }).join('');
        }
        setSearchState('results');
      })
      .catch(function () { if (seq === searchSeq) setSearchState('none'); });
  }
  on(searchInput, 'input', function () {
    var q = searchInput.value;
    clearTimeout(searchTimer);
    if (q.trim() === '') { setSearchState('idle'); lastQuery = ''; return; }
    searchTimer = setTimeout(function () { runSearch(q); }, 180);
  });
  $$('[data-itz-search-form]').forEach(function (f) {
    on(f, 'submit', function (e) {
      var inp = f.querySelector('input[name="q"]'), q = inp ? inp.value : '';
      pushRecent(q);
      if (window.ItzSearch && ItzSearch.scope(q)) { e.preventDefault(); location.href = ItzSearch.url(q); }   /* field-scoped query, shopper's words in &terms= */
    });
  });
  on(doc, 'click', function (e) { var go = e.target.closest('[data-itz-search-go]'); if (go && window.ItzSearch) { e.preventDefault(); location.href = ItzSearch.url(go.getAttribute('data-itz-search-go')); } });
  on(search, 'click', function (e) {
    var term = e.target.closest('[data-itz-search-term]');
    if (term && searchInput) {
      searchInput.value = term.getAttribute('data-itz-search-term');
      searchInput.focus();
      runSearch(searchInput.value);
    }
  });

  /* ---- Cart drawer ------------------------------------------------------------------ */
  var cart = $('[data-itz-cart]');
  var cartOpen = false;
  var SECTION_ID = 'itz-cart-drawer';

  function setCart(open) {
    if (!cart) return;
    cartOpen = open;
    cart.hidden = !open;
    lockScroll(open);
    if (open) {
      closePanels(); closeSearch(); if (drawerOpen) setDrawer(false);
      var closeBtn = $('[data-itz-cart-close].itz-cart__close', cart);
      if (closeBtn) closeBtn.focus();
      loadUpsells();
      syncExpress();
    }
  }
  /* Express checkout (Shopify's <shopify-accelerated-checkout-cart>) picks its own layout from the width it gets: stacked on most phones,
     one row of icon buttons on wider ones. The phone 2 × 2 styles only make sense for the stacked case, so measure and flag it. */
  var expressRO = null, expressTimer = null;
  function syncExpress() {
    var box = cart && $('.itz-cart__express', cart); if (!box) return;
    var acc = box.querySelector('shopify-accelerated-checkout-cart'); if (!acc) return;
    var apply = function () {
      box.classList.remove('is-stacked');
      var kids = Array.prototype.slice.call(acc.children).filter(function (k) { return k.getBoundingClientRect().height > 0; });
      if (kids.length < 2) return;
      var first = kids[0].getBoundingClientRect();
      var stacked = kids.every(function (k) { var r = k.getBoundingClientRect(); return Math.abs(r.left - first.left) < 2; });
      box.classList.toggle('is-stacked', stacked && window.innerWidth <= 767);
    };
    apply();
    clearTimeout(expressTimer); expressTimer = setTimeout(apply, 400);   /* the component renders its buttons a beat after the drawer opens */
    if (!expressRO && 'ResizeObserver' in window) { expressRO = new ResizeObserver(function () { if (cartOpen) apply(); }); }
    if (expressRO) { expressRO.disconnect(); expressRO.observe(acc); expressRO.observe(box); }
  }
  on(window, 'resize', function () { if (cartOpen) syncExpress(); });
  $$('[data-itz-cart-open]').forEach(function (el) {
    on(el, 'click', function (e) { e.preventDefault(); setCart(true); });
  });
  on(cart, 'click', function (e) {
    if (e.target.closest('[data-itz-cart-close]')) { setCart(false); return; }
    var qb = e.target.closest('[data-itz-qty-change]');
    if (qb) {
      var line = qb.closest('[data-itz-line]');
      var cur = parseInt($('[data-itz-qty-value]', line).textContent, 10) || 1;
      changeLine(line.getAttribute('data-line-key'), Math.max(0, cur + parseInt(qb.getAttribute('data-itz-qty-change'), 10)));
      return;
    }
    var rm = e.target.closest('[data-itz-line-remove]');
    if (rm) { changeLine(rm.closest('[data-itz-line]').getAttribute('data-line-key'), 0); return; }
    var up = e.target.closest('[data-itz-upgrade]');
    if (up) {
      var l = up.closest('[data-itz-line]');
      upgradeLine(l.getAttribute('data-line-key'), up.getAttribute('data-itz-upgrade'), parseInt(up.getAttribute('data-quantity'), 10) || 1);
      return;
    }
    var nt = e.target.closest('[data-itz-note-toggle]');
    if (nt) {
      var panel = $('#itz-cart-note', cart);
      var open = nt.getAttribute('aria-expanded') === 'true';
      nt.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) { panel.hidden = open; if (!open) { var f = $('[data-itz-note-field]', panel); if (f) f.focus(); } }
    }
  });
  var noteTimer = null;
  on(cart, 'input', function (e) {
    var f = e.target.closest('[data-itz-note-field]');
    if (!f) return;
    clearTimeout(noteTimer);
    // A drawer never submits the cart form — the note must be saved by JS.
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: f.value }) });
    }, 500);
  });

  function sectionsParam() { return '&sections=' + SECTION_ID + '&sections_url=' + encodeURIComponent(window.location.pathname); }
  function renderCartFrom(json) {
    if (!cart) return;
    var html = json && json.sections && json.sections[SECTION_ID];
    if (!html) return refreshCart();
    var tmp = doc.createElement('div'); tmp.innerHTML = html;
    var fresh = $('[data-itz-cart-content]', tmp);
    var current = $('[data-itz-cart-content]', cart);
    if (fresh && current) {
      var noteOpen = ($('[data-itz-note-toggle]', current) || {}).getAttribute && $('[data-itz-note-toggle]', current).getAttribute('aria-expanded') === 'true';
      current.replaceWith(fresh);
      if (noteOpen) { var nt = $('[data-itz-note-toggle]', fresh); var np = $('#itz-cart-note', fresh); if (nt && np) { nt.setAttribute('aria-expanded', 'true'); np.hidden = false; } }
      updateBadge(parseInt(fresh.getAttribute('data-count'), 10) || 0);
      loadUpsells();
      if (cartOpen) syncExpress();
    }
  }
  function refreshCart() {
    // Single-section render (?section_id=) returns HTML and works through the theme-dev proxy;
    // the JSON ?sections= form is refused there.
    return fetch(window.location.pathname + '?section_id=' + SECTION_ID, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { var o = {}; o[SECTION_ID] = html; renderCartFrom({ sections: o }); })
      .catch(function () {});
  }
  function updateBadge(n) {
    $$('[data-itz-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
  }
  function postCart(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    if (cart) cart.classList.add('is-busy');
    postCart('/cart/change.js', { id: key, quantity: qty, sections: SECTION_ID, sections_url: window.location.pathname })
      .then(renderCartFrom).catch(refreshCart).then(function () { if (cart) cart.classList.remove('is-busy'); });
  }
  function upgradeLine(key, newVariantId, qty) {
    if (cart) cart.classList.add('is-busy');
    postCart('/cart/change.js', { id: key, quantity: 0 })
      .then(function () { return postCart('/cart/add.js', { items: [{ id: parseInt(newVariantId, 10), quantity: qty }], sections: SECTION_ID, sections_url: window.location.pathname }); })
      .then(renderCartFrom).catch(refreshCart).then(function () { if (cart) cart.classList.remove('is-busy'); });
  }
  function loadUpsells() {
    var box = cart && $('[data-itz-cart-upsells]', cart);
    if (!box) return;
    var pid = box.getAttribute('data-product-id');
    var list = $('[data-itz-cart-upsell-list]', box);
    if (!pid || !list || box.getAttribute('data-loaded') === pid) return;
    box.setAttribute('data-loaded', pid);
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(base + 'recommendations/products?section_id=itz-upsell-json&product_id=' + pid + '&limit=2&intent=related', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-itz-upsells[^>]*>([\s\S]*?)<\/script>/);
        var items = m ? JSON.parse(m[1]) : [];
        if (!items.length) { box.hidden = true; return; }
        list.innerHTML = items.slice(0, 2).map(function (p) {
          var img = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '<span class="itz-placeholder">Print</span>';
          return '<div class="itz-cart__upsell"><a class="itz-cart__upsell-img" href="' + escapeHtml(p.url) + '">' + img + '</a>' +
            '<div class="itz-cart__upsell-main"><a class="itz-cart__upsell-title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
            '<span class="itz-cart__upsell-meta">' + (p.price_varies ? 'From ' : '') + formatPrice(p.price / 100) + '</span></div>' +
            '<button type="button" class="itz-cart__upsell-add" data-itz-qa="' + escapeHtml(p.handle) + '">Quick add</button></div>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; });
  }

  // Every add to cart opens the drawer in place — never navigates.
  on(doc, 'submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-itz-native-submit')) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('sections', SECTION_ID);
    fd.append('sections_url', window.location.pathname);
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.status && json.status !== 200) { form.dispatchEvent(new CustomEvent('itz:cart:error', { detail: json, bubbles: true })); return; }
        renderCartFrom(json);
        setCart(true);
        form.dispatchEvent(new CustomEvent('itz:cart:added', { detail: json, bubbles: true }));
      })
      .catch(function () { form.removeAttribute('data-itz-native-submit'); form.setAttribute('data-itz-native-submit', ''); form.submit(); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* ---- Footer groups: open on desktop, collapsible on mobile ------------------------- */
  var mqMobile = window.matchMedia('(max-width: 767px)');
  function syncFooter() {
    $$('[data-itz-footer-group]').forEach(function (d) { if (!mqMobile.matches) d.open = true; else if (!d.__itzTouched) d.open = false; });
  }
  $$('[data-itz-footer-group]').forEach(function (d) { on(d, 'toggle', function () { d.__itzTouched = true; }); });
  syncFooter();
  on(mqMobile, 'change', syncFooter);

  /* ---- Accordion (handoff §3.5): button + grid-rows panel ------------------------------- */
  on(doc, 'click', function (e) {
    var trig = e.target.closest('[data-itz-acc-trigger]');
    if (!trig) return;
    var item = trig.closest('[data-itz-acc]');
    if (!item) return;
    var open = !item.classList.contains('is-open');
    // One open at a time within a group (At a glance is marked independent and is left alone)
    if (open && !item.hasAttribute('data-itz-acc-independent')) {
      var group = item.parentElement;
      $$('[data-itz-acc].is-open:not([data-itz-acc-independent])', group).forEach(function (o) { if (o !== item && o.parentElement === group) { o.classList.remove('is-open'); var t = $('[data-itz-acc-trigger]', o); if (t) t.setAttribute('aria-expanded', 'false'); } });
    }
    item.classList.toggle('is-open', open);
    trig.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- Generic quantity stepper for forms: [data-itz-stepper] wraps an <input> ---------- */
  on(doc, 'click', function (e) {
    var btn = e.target.closest('[data-itz-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-itz-stepper]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10), max = input.max ? parseInt(input.max, 10) : Infinity;
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-itz-step'), 10);
    next = Math.max(min, Math.min(max, next));
    input.value = next;
    var dec = wrap.querySelector('[data-itz-step^="-"]');
    if (dec) dec.disabled = next <= min;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Generic note/disclosure toggle: [data-itz-toggle="#id"] ------------------------- */
  on(doc, 'click', function (e) {
    var t = e.target.closest('[data-itz-toggle]');
    if (!t) return;
    var target = doc.querySelector(t.getAttribute('data-itz-toggle'));
    if (!target) return;
    var open = target.hidden;
    target.hidden = !open;
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var f = target.querySelector('textarea, input, select'); if (f) f.focus(); }
  });

  /* ---- In-page anchors scroll smoothly (the only smooth scrolling on the site) ------------------- */
  on(doc, 'click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a || a.getAttribute('href').length < 2) return;
    var t = doc.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(history.state, '', a.getAttribute('href'));
  });

  /* ---- Escape closes everything --------------------------------------------------------- */
  on(doc, 'keydown', function (e) {
    if (e.key !== 'Escape') return;
    closePanels(); closeSearch();
    if (drawerOpen) setDrawer(false);
    if (cartOpen) setCart(false);
  });

  // Public hooks for later modules (quick add, sticky bar, PDP)
  // Newsletter forms → Klaviyo list first (client Subscriptions API, public key, keepalive so the request
  // survives Shopify's own form post that follows), then Shopify's customer form proceeds as normal.
  $$('form.itz-news[data-itz-klaviyo]').forEach(function (form) {
    var list = (form.getAttribute('data-itz-klaviyo') || '').trim(), company = (form.getAttribute('data-itz-klaviyo-company') || '').trim();
    if (!list || !company) return;
    on(form, 'submit', function () {
      var email = (form.querySelector('input[name="contact[email]"]') || {}).value || ''; if (!/.+@.+\..+/.test(email)) return;
      var first = (form.querySelector('input[name="contact[first_name]"]') || {}).value || '', last = (form.querySelector('input[name="contact[last_name]"]') || {}).value || '';
      var attrs = { email: email.trim(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (first.trim()) attrs.first_name = first.trim(); if (last.trim()) attrs.last_name = last.trim();
      var body = { data: { type: 'subscription', attributes: { custom_source: form.getAttribute('data-itz-source') || 'Newsletter', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
      try { fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body) }).catch(function () {}); } catch (_) {}
    });
  });
  // Obfuscated support email (see layout/theme.liquid): rebuild the mailto and the readable text
  (function () {
    document.querySelectorAll('[data-itz-mail]').forEach(function (a) {
      var addr = a.getAttribute('data-itz-mail') + '@' + a.getAttribute('data-itz-host'); a.setAttribute('href', 'mailto:' + addr);
      a.querySelectorAll('.itz-mail-rev').forEach(function (s) { s.textContent = addr; s.classList.remove('itz-mail-rev'); });
    });
    document.querySelectorAll('.itz-mail-rev').forEach(function (s) { s.textContent = s.textContent.split('').reverse().join(''); s.classList.remove('itz-mail-rev'); });
  })();
  window.ItzShell = { openCart: function () { setCart(true); }, closeCart: function () { setCart(false); }, refreshCart: refreshCart, openSearch: openSearch };
})();
